import { FunctionComponent } from 'react';

import ProductInfoModel, { SectionTypes }  from 'models/ProductInfo';

import ProductInfoComponent from 'components/modules/public/layout/sections/ProductInfo';

import StyledComponent from './styles';
import { Props } from './types';

const PublicPageProductSectionProductInfo: FunctionComponent<Props> = ({
    translations,
    infos,
}) => {
    const {
        headline,
        indicationsSubheadline,
        indications,
        contraindicationsSubheadline,
        contraindications,
        benefitsSubheadline,
        benefits,
    } = translations;

    const productInfos = infos && infos.length > 0 ? infos : [
        ...(Array.isArray(indications) ? indications.map((item, index) => new ProductInfoModel({
            id: `indications-${index}`,
            section: SectionTypes.Indications,
            description: item.description,
            order: index,
        })) : []),
        ...(Array.isArray(contraindications) ? contraindications.map((item, index) => new ProductInfoModel({
            id: `contraindications-${index}`,
            section: SectionTypes.Contraindications,
            description: item.description,
            order: index,
        })) : []),
        ...(Array.isArray(benefits) ? benefits.map((item, index) => new ProductInfoModel({
            id: `benefits-${index}`,
            section: SectionTypes.Benefits,
            description: item.description,
            order: index,
        })) : []),
    ];

    return (
        <StyledComponent className="public-page-product-section-product-info">
            <ProductInfoComponent
                infos={productInfos}
                headline={headline}
                subheadlines={{
                    [SectionTypes.Benefits]: benefitsSubheadline || '',
                    [SectionTypes.Indications]: indicationsSubheadline || '',
                    [SectionTypes.Contraindications]: contraindicationsSubheadline || '',
                }}
            />
        </StyledComponent>
    );
};

export default PublicPageProductSectionProductInfo;
